const PromotionCard = ({ category, title, description, buttonText }) => {
  return (
    <div className="col-xxl-6">
      <div className="Promotions__card d-flex align-items-center justify-content-center justify-content-sm-between flex-wrap flex-sm-nowrap gap-6 p-4 p-lg-10 rounded-8 p3-bg">
        <div className="Promotions__card-thumb text-center">
          <img src="/assets/images/promotion2.png" alt="Icon" />
        </div>
        <div className="Promotions__card-content text-center text-sm-start">
          <h5 className="mb-3">{category}</h5>
          <span className="fs-three mb-2 mb-md-3 d-block">{title}</span>
          <span className="fs-six mb-4 mb-md-5 d-block opacity-50">
            {description}
          </span>
          <button type="button" className="cmn-btn px-5 py-3">
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromotionCard;
